<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand py-0" href="">
      <img src="@/assets/tawitech.png" alt="" height="50">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto"></ul>
      <div class="form-inline my-2 my-lg-0">
        <button class="btn btn-secondary" @click="openLeaderboard">
          Open Leaderboard&nbsp; <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppHeader',
  methods: {
    openLeaderboard() {
      const currentRoute = window.location.href;
      window.open(`${currentRoute}leaderboard`, `_blank`); 
    }
  }
}
</script>

<style scoped>
.header-button {
  background-color: #A26E14; 
  color: white;
}
</style>